/*
 * This work has been created or enhanced by
 *   Markus Luckey, 2025, KERNBLICK GmbH
 *
 * This file is covered by the EU PL 1.2 license.
 * You may obtain a copy of the licence at
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 */

import { DOMAIN } from '@/EnvProvider';

export default {
  async fetchApps() {
    return window.apps.map(app => ({
      ...app,
      url: app.url.replace('${DOMAIN}', DOMAIN)
    }));
  },

  async getAll() {
    return this.fetchApps();
  },
};
